import Infography from './Infography';

export default Infography;
